import { BaseQueryDTO } from './basequery-dto';

export class UpdateProposalPhysicalInspectionDTO {
    ProposalId: number;
    IsPhysicalInspectionPass: boolean;
    RejectionComment: string;
    UserBypassedActiveProposalWarning: boolean;
}
